import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import ContactPhoneRoundedIcon from '@mui/icons-material/ContactPhoneRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import countries from 'i18n-iso-countries';
import thCountryLocale from 'i18n-iso-countries/langs/th.json';

countries.registerLocale(thCountryLocale);
// รายชื่อประเทศ (ภาษาไทย) จาก i18n-iso-countries — bundled มากับโค้ด ไม่ต้องพึ่ง API ภายนอก
export const COUNTRY_OPTIONS = Object.values(countries.getNames('th', { select: 'official' })).sort((a, b) => a.localeCompare(b, 'th'));

export const clientFields = [
  {
    name: 'contact_type',
    label: 'ประเภทผู้ติดต่อ',
    type: 'select',
    options: [
      { value: 'นิติบุคคล', label: 'นิติบุคคล' },
      { value: 'บุคคลธรรมดา', label: 'บุคคลธรรมดา' },
    ],
  },
  { name: 'name', label: 'ชื่อธุรกิจ/ชื่อบุคคล' },
  { name: 'business_location', label: 'ประเทศ', type: 'autocomplete', options: COUNTRY_OPTIONS },
  { name: 'address1', label: 'บ้านเลขที่/หมู่/ซอย/ถนน' },
  { name: 'zipcode', label: 'รหัสไปรษณีย์' },
  { name: 'province', label: 'จังหวัด' },
  { name: 'amphoe', label: 'อำเภอ' },
  { name: 'tambon', label: 'ตำบล' },
  { name: 'taxId', label: 'เลขผู้เสียภาษี' },
  { name: 'branch_code', label: 'รหัสสาขา' },
  { name: 'office_branch', label: 'สำนักงาน/สาขา' },
  { name: 'contact_name', label: 'ชื่อผู้ติดต่อ' },
  { name: 'email', label: 'อีเมล', type: 'email' },
  { name: 'mobile', label: 'เบอร์มือถือ' },
  { name: 'credit_days', label: 'เครดิต (วัน)', type: 'number' },
  { name: 'office_phone', label: 'เบอร์สำนักงาน' },
  { name: 'fax', label: 'เบอร์โทรสาร' },
  { name: 'website', label: 'เว็บไซต์' },
  { name: 'line_id', label: 'LINE ID' },
];

export const emptyValues = clientFields.reduce((acc, f) => ({ ...acc, [f.name]: '' }), {});

// จัดกลุ่ม field ในฟอร์มเพิ่ม/แก้ไขลูกค้าให้เป็นหมวดหมู่ที่อ่านง่าย — สีต่างกันต่อหมวดช่วยแยกสายตาได้เร็วขึ้น
export const FIELD_GROUPS = [
  { key: 'general', label: 'ข้อมูลทั่วไป', icon: BusinessRoundedIcon, colorKey: 'primary', fieldNames: ['contact_type', 'name'] },
  { key: 'address', label: 'ที่อยู่', icon: LocationOnRoundedIcon, colorKey: 'info', fieldNames: ['business_location','address1', 'zipcode', 'province', 'amphoe', 'tambon'] },
  { key: 'tax', label: 'ข้อมูลภาษี/สาขา', icon: ReceiptLongRoundedIcon, colorKey: 'warning', fieldNames: ['taxId', 'branch_code', 'office_branch'] },
  { key: 'contact', label: 'ผู้ติดต่อ', icon: ContactPhoneRoundedIcon, colorKey: 'success', fieldNames: ['contact_name', 'email', 'mobile', 'office_phone', 'fax', 'website', 'line_id'] },
  { key: 'credit', label: 'เครดิต', icon: PaymentsRoundedIcon, colorKey: 'secondary', fieldNames: ['credit_days'] },
];

export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '96vw', md: '90vw' },
  maxWidth: 1000,
  maxHeight: '94vh',
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};
